<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Late Night Poetry</span></p>
<p class="p0">By Nell Iris</p>
<p class="p2"><a id="a4"></a><a href="#/005#a18">Monday, October 22, 1990</a></p>
<p class="p2"><span href="#/006#a19" title="Link target outside of Sample">Saturday, October 27, 1990. 3:30 A.M.</span></p>
<p class="p2"><span href="#/007#a20" title="Link target outside of Sample">Saturday, October 27, 1990. 12:47 P.M.</span></p>
<p class="p2"><span href="#/008#a21" title="Link target outside of Sample">Thursday, November 5, 1990. 6:14 P.M.</span></p>
<p class="p2"><span href="#/009#a22" title="Link target outside of Sample">Friday, November 23, 1990. 11:57 PM</span></p>
<p class="p2"><span href="#/010#a23" title="Link target outside of Sample">Sunday, November 25, 1990. 11:35 P.M.</span></p>
<p class="p2"><span href="#/011#a24" title="Link target outside of Sample">Wednesday, November 28, 1990. 5:54 P.M.</span></p>
<p class="p2"><span href="#/012#a25" title="Link target outside of Sample">Friday, November 30, 1990. 5:04 P.M.</span></p>
<p class="p2"><span href="#/013#a26" title="Link target outside of Sample">Sunday, December 2, 1990. 1:25 A.M.</span></p>
<p class="p2"><span href="#/014#a27" title="Link target outside of Sample">Monday, December 17, 1990. 7:19 P.M.</span></p>
<p class="p2"><span href="#/015#a28" title="Link target outside of Sample">Wednesday, December 19, 1990. 8:21 P.M.</span></p>
<p class="p2"><span href="#/016#a29" title="Link target outside of Sample">Friday, June 26, 2015. 12:43 P.M.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?3e579e00